/**
 * Directive v-otp-autofocus: tu dua con tro vao o nhap OTP ngay khi o do XUAT HIEN trong DOM.
 *
 * VI SAO CAN DIRECTIVE thay vi goi $refs.focus() thu cong tung cho:
 *  - Cac o OTP nam trong b-modal (BootstrapVue) render qua transition. Goi focus() o $nextTick
 *    ngay sau .show() thi phan tu CHUA vao DOM / chua visible -> focus() im lang khong an.
 *  - Cac o OTP nam trong nhanh v-if cua modal NHIEU BUOC (vd QrEnrollModal buoc 3, ModalThemThietBiQr
 *    buoc 1). Hook @shown cua modal ban o buoc 1 -> qua som so voi luc o OTP that su hien ra.
 *  - Hook `inserted` cua Vue 2 ban DUNG luc phan tu vua duoc chen vao DOM cha, ke ca khi phan tu do
 *    xuat hien tre do v-if doi nhanh. Day la ly do directive xu ly duoc CA modal 1 buoc, modal nhieu
 *    buoc lan trang tinh ma khong can magic setTimeout.
 *
 * CACH DUNG: dat truc tiep len <b-form-input> / <b-input> / <input> cua o OTP:
 *     <b-form-input v-otp-autofocus v-model="otp" ... />
 *
 * KHONG dung cho <v-otp-input> (@bachdgvn/vue-otp-input): component do da tu quan ly focus qua prop
 * :should-auto-focus="true". Them directive ben ngoai se da nhau voi focus noi bo cua no.
 */

// Delay 1 frame sau khi phan tu vao DOM. Ly do: voi b-modal, `inserted` co the ban khi modal con
// dang trong transition (opacity/transform) - vai trinh duyet bo qua focus() tren phan tu chua
// visible. requestAnimationFrame day lenh focus sang frame ke tiep, luc layout da on dinh.
// Fallback setTimeout(0) cho moi truong khong co rAF (jsdom trong unit test).
function focusOnNextFrame(el) {
  const run = () => {
    // Phan tu co the da bi go khoi DOM truoc khi callback chay (user dong modal ngay lap tuc).
    if (!el || !el.isConnected) return;
    // Guard input disabled/readonly: focus() vao do vo nghia va co the cuop focus khoi phan tu khac.
    if (el.disabled || el.readOnly) return;
    el.focus();
    // select() de neu o dang co san gia tri cu thi go de len luon, khong phai xoa tay.
    if (typeof el.select === "function") el.select();
  };

  if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
    window.requestAnimationFrame(run);
  } else {
    setTimeout(run, 0);
  }
}

// BootstrapVue <b-form-input> render ra <input> that o goc, nen el thuong da la <input>.
// Nhung neu directive bi dat len wrapper (vd <div> boc input), tim <input> dau tien ben trong.
function resolveInputEl(el) {
  if (!el) return null;
  if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") return el;
  return el.querySelector("input, textarea");
}

export default {
  inserted(el) {
    focusOnNextFrame(resolveInputEl(el));
  },
};
